import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  darkMode: false,
  name: 'default',
  list: ['default', 'dark'],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
